import { useNavigate } from "react-router-dom";
import { Form } from "antd";
import { useSendPhoneVerificationCodeMutation } from "apis/services/auth";
import Text from "components/general/Text";
import TextInput from "components/inputs/TextInput";
import Button from "components/general/Button";
import showSuccessMsg from "utils/showSuccessMsg";
import styles from "./styles.module.scss";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [sendPhoneVerificationCode, { isLoading }] =
    useSendPhoneVerificationCodeMutation();
    
  const handleSubmit = (values: { phone: string }) => {
    sendPhoneVerificationCode(values)
      .unwrap()
      .then(() => {
        showSuccessMsg({ msg: "Code has been sent." });
        navigate(`/auth/verify-code/?phone=${values.phone}`);
      });
  };

  return (
    <>
      <Text className={styles.title}>Forgot password</Text>
      <Text className={styles.secondaryTitle}> </Text>
      <Form
        className={styles.form}
        autoComplete="off"
        autoCorrect="off"
        onFinish={handleSubmit}
      >
        <Form.Item
          name="phone"
          rules={[
            { required: true },
            {
              min: 10,
              max: 15,
              message: "Phone number must be between 10 and 15 digits.",
            },
          ]}
        >
          <TextInput label="Phone" />
        </Form.Item>

        <Button
          btnClassName={styles.submitBtn}
          isLoading={isLoading}
          type="submit"
        >
          Submit
        </Button>
      </Form>
    </>
  );
}
